// extracted by mini-css-extract-plugin
export default {"wrapper":"components-Picture-styles__wrapper--uJV2R","missingHeight":"components-Picture-styles__missingHeight--TfaMe"};